<template>
<div
  class='assessment-result'
  :class='main_class'
>
  <div class='assessment-result_inner'>
    <div class='assessment-result_inner-left'>
      <div class='assessment-result_headline'>
        {{ feedback.headline }}
      </div>

      <div
        class='assessment-result_message'
        v-html='feedback.text'
      />

      <button
        class='assessment-result_done button-one-light'
        @click='close'
      >
        {{ $t('done') }}
      </button>
    </div>

    <div class='assessment-result_box'>
      <div
        v-if='show_attempt_number'
        class='assessment-result_box-headline body-four'
      >
        {{ $t('attempt') }} {{ attempt_number }}
      </div>

      <div
        v-if='score'
        class='assessment-result_box-percent'
      >
        {{ score }}<span>%</span>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: ['close', 'result', 'slide_result', 'activity'],

  computed: {
    main_class() {
      return 'assessment-result--' + (this.result.passed ? 'passed' : 'failed')
    },

    score() {
      return '' + this.result.score
    },

    feedback() {
      if (this.activity.previous_attempt.passed) {
        return this.activity.feedback.passed
      } else {
        return this.activity.feedback.failed
      }
    },

    attempt_number() {
      return this.slide_result.results.attempts ? this.slide_result.results.attempts.filter((a) => a.passed !== null).length : 1
    },

    show_attempt_number() {
      return this.activity.multiple_attempts
    }
  }
}
</script>

<style lang='sass' scoped>
@import './result'
</style>
